// src/screens/my-bookings/params/booking-list.screen.jsx
import React from "react";
import PropTypes from "prop-types";
import BookingCardItem from "../../../components/card-items/booking-card-item/booking-card-item.component";

const BookingListScreen = ({ bookings, onStatusChange }) => {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 w-full">
      {bookings.map((booking) => (
        <BookingCardItem 
          key={booking.id} 
          property={booking} 
          onStatusChange={onStatusChange} 
        />
      ))}
    </div>
  );
};

BookingListScreen.propTypes = {
  bookings: PropTypes.array.isRequired,
  onStatusChange: PropTypes.func.isRequired,
};

export default BookingListScreen;